import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-personal-info',
  templateUrl: './text-personal-info.component.html',
  styleUrls: ['./text-personal-info.component.css'],
})
export class TextPersonalInfoComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit() {
  }

}
